// extracted by mini-css-extract-plugin
export default {"progressLoading":"progressLoading_progressLoading__KQHk5"};